import { render } from "./IdeaStatisticsView.vue?vue&type=template&id=f0be72f4&scoped=true&ts=true"
import script from "./IdeaStatisticsView.vue?vue&type=script&lang=ts"
export * from "./IdeaStatisticsView.vue?vue&type=script&lang=ts"

import "./IdeaStatisticsView.vue?vue&type=style&index=0&id=f0be72f4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0be72f4"]])

export default __exports__